<template>
  <div>
    <div>
      <div class="grid-container">
        <header class="header">
          <div class="header_search">Search...</div>
        </header>
        <main class="main">
          <div class="main_overview">

            <div class="overview_card bg-blue">
              <div class="overview_card-info">
                <!-- <VueJsCounter class="metricsNo" end="205"></VueJsCounter> -->
                <p class="metricsDesc">subscriptions</p>
              </div>
              <div class="overview_card-info">
                <!-- <VueJsCounter class="metricsNo" end="355"></VueJsCounter> -->
                <p class="metricsDesc">active plans</p>
              </div>
            </div>

            <div class="overview_card bg-blue">
              <div class="overview_card-info">
                <!-- <VueJsCounter class="metricsNo" end="450"></VueJsCounter> -->
                <p class="metricsDesc">unit stores open</p>
              </div>
              <div class="overview_card-info">
                <!-- <VueJsCounter class="metricsNo" end="5"></VueJsCounter> -->
                <p class="metricsDesc">average units <br/> per plan</p>
              </div>
            </div>

            <div class="overview_card bg-blue">
              <div class="overview_card-info">
                <!-- <VueJsCounter class="metricsNo2" end="450"></VueJsCounter> -->
                <span class="metricsUnit">GB</span>
                <p class="metricsDesc">data storage used</p>
              </div>
              <div class="overview_card-info">
                <!-- <VueJsCounter class="metricsNo2" end="5"></VueJsCounter> -->
                <span class="metricsUnit">GB</span>
                <p class="metricsDesc">average data used <br/> per plan</p>
              </div>
            </div>

            <div class="overview_card bg-gray">
              <div class="overview_card-info">Recent Client Feedbacks</div>
            </div>
          </div>

          <div class="main_cards">
            <div class="card">
              <WorldMap/>
            </div>
            <div class="card bgLightGray">
              <h3 class="metricsInitals">TOP CLIENTS</h3>
            </div>
            <div class="card bgLightGray">
              <h3 class="metricsInitals">TOP PRODUCTS</h3>
            </div>
          </div>
        </main>
        <footer class="footer">
          <div class="footer_copyright">&copy;{{ new Date().getFullYear() }}</div>
          <div class="footer_byline">ExpAR store</div>
      </footer>
      </div>
    </div>
  </div>
</template>

<script>

// import VueJsCounter from 'vue-js-counter'
import WorldMap from './../components/ui/WorldMap.vue'


export default {
components: { 
  // VueJsCounter,
  WorldMap
 }
}
</script>

<style lang="scss" scoped>


* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-size: 15px;
}

.graphTitle {
  font-size: 2em;
  color: var(--br);
}
.stockAlert {
  color: tomato;
}

.metricsNo {
  font-size: 3em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}
.metricsNo2 {
  font-size: 2em;
  font-weight: 800;
  padding-left: 2px;
  display: inline;
}

.metricsDesc {
  letter-spacing: 1px;
  text-align: center !important;
}
.metricsUnit {
  font-size: 1.5em;
}
.bgLightGray {
  background-color: var(--grey-light);
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 50px 1fr 50px;
  grid-template-areas:
  'header'
  'main'
  'footer';
  height: 100vh;
  }
  .header {
        grid-area: header;
        background-color: rgb(224, 223, 223);
      }
  .main {
        grid-area: main;
        background-color: white;
      }
  .footer {
        grid-area: footer;
        background-color: var(--bg);
      }
.feedback {
  color: var(--bg);
}
::v-deep .clientFeedbackModal {
color: var(--bg) !important;
text-align: left;
    }


.edit-btn {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 200px;
  height: 30px;
}

.edit-btn2 {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  margin: auto !important;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 200px;
  height: 60px;
  font-size: 0.6em;
}
    /* flexing header and footer*/
.header,
.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: white;
  padding: 0 15px;
}

.circleTitle {
  font-size: 12px;
}
.circleNo {
  font-size: 17px;
  }

.overview_card-info p {
  text-align: left;
  margin: 0;
  padding: 0;
}
      /* Layout for main content overview  and its cards*/
      .main_overview {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        border-bottom: 1px solid lightgreen;
      }
      .overview_card {
        flex-basis: 250px;
        flex-grow: 1;
        margin: 10px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px;
        /* background-color: seagreen; */
        height: 180px;
        border: 1px solid white;
        border-radius: 4px;
        color: white;
      }
      /* Layout for main-cards section // below main_overview */
      .main_cards {
        margin: 10px;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: 500px 200px 300px;
        grid-template-areas:
          'card1'
          'card2'
          'card3';
        grid-gap: 10px;
      }
      .card {
        padding: 20px;
        border-radius: 4px;
      }

      .card:first-child {
        grid-area: card1;
      }
      .card:nth-child(2) {
        grid-area: card2;
      }
      .card:nth-child(3) {
        grid-area: card3;
      }

.bg-blue {
  background: var(--bg);
  border: none;
}
.bg-gray {
  background: var(--gray);
  border: none;
}

.header_search {
  margin-left: 24px;
  color: var(--bg);
}

.about-img2 {
  display: inline-block;
  width: 100%;
  max-width: 500px;
  text-align: center;
  vertical-align: top;
}
.img-wrapper {
  width: auto;
  position: relative;
}
.img-wrapper > img {
  position: relative;
}
      /* responsive layout */
      @media only screen and (min-width: 750px) {
        .grid-container {
          display: grid;
          grid-template-columns: 1fr;
          grid-template-rows: 50px 1fr 50px;
          grid-template-areas:
            'header'
            'main'
            'footer';
          height: 100vh;
        }

        .main_cards {
          margin: 10px;
          display: grid;
          grid-template-columns: 2fr 1fr;
          grid-template-rows: 200px 300px;
          grid-template-areas:
            'card1 card2'
            'card1 card3';
          grid-gap: 10px;
        }
      }

</style>